<template>
  <section class="start_your_project">
    <p class="wow fadeInUp" data-wow-offset="100">
      {{ startYourProjectData.title }}
    </p>
    <article class="content">
      <div class="desc_side wow fadeInUp" data-wow-offset="150">
        <p>
          {{ startYourProjectData.desc }}
        </p>
        <button @click="navigateToLink(startYourProjectData.btnNavigationLink)">
          {{ startYourProjectData.btnText }}
        </button>
        <div class="social_accounts">
          <a :href="'mailto:' + contactData.email" target="_blank">
            <i class="far fa-envelope"></i
          ></a>
          <a :href="contactData.socialLinks.instagram" target="_blank">
            <i class="fab fa-instagram"></i
          ></a>
          <a :href="contactData.socialLinks.youtube" target="_blank">
            <i class="fab fa-youtube"></i
          ></a>
          <a :href="contactData.socialLinks.facebook" target="_blank">
            <i class="fab fa-facebook-f"></i
          ></a>
        </div>
      </div>
      <div class="img_side wow fadeInUp" data-wow-offset="150">
        <img
          src="@/assets/startYourProject.png"
          alt="Start Your Work "
          loading="lazy"
          draggable="false"
        />
      </div>
    </article>
  </section>
</template>

<script>
import store from "@/store";
export default {
  name: "StartYourProject",
  computed: {
    startYourProjectData() {
      const { lang } = store.state;
      return store.state[lang].homePage.startYourProject;
    },
    contactData() {
      const { lang } = store.state;
      return store.state[lang].footerContent;
    },
  },
  methods: {
    navigateToLink(link) {
      if (link) {
        this.$router.push(link);
      }
    },
  },
};
</script>
